import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { mapEntityTypeFromTarget } from '@shared/mappers/map-entity-type-from-target';
import { EntityType } from 'src/app/modules/admin/models/entity-type';
import { InvestmentJurisdictionShort } from 'src/app/modules/admin/models/investment-jurisdiction-short';
import { TargetEntityType } from 'src/app/modules/admin/models/target-entity-type';

@Component({
  standalone: false,
  selector: 'gstar-selected-investment-jurisdiction-component',
  templateUrl: './selected-investment-jurisdiction-component.component.html',
  styleUrl: './selected-investment-jurisdiction-component.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedInvestmentJurisdictionComponent {
  invJurisdiction = input<InvestmentJurisdictionShort>();
  targetEntityType = input<TargetEntityType>();
  index = input<number>();

  removeInvestmentJurisdiction = output<number>();
  targetEntityChangeOutput = output<EntityType | undefined>();

  defaultTargetEntityType = computed(() => {
    if (this.targetEntityType()?.entityTypeId) {
      return mapEntityTypeFromTarget(this.targetEntityType()!);
    }
    return null;
  });

  get title(): string {
    return this.invJurisdiction()?.country?.name ?? '';
  }

  handleTargetEntityTypeChange(
    targetEntityTypeValue: EntityType | null | undefined
  ): void {
    if (targetEntityTypeValue)
      this.targetEntityChangeOutput.emit(targetEntityTypeValue);
  }

  onRemove(): void {
    this.removeInvestmentJurisdiction.emit(this.index()!);
  }

  clearTargetEntityTypeValue(): void {
    this.targetEntityChangeOutput.emit(undefined);
  }
}
